import { Activity, Bandage, ClipboardCheck, ClipboardList, Dumbbell, Flag, HandHeart, type LucideIcon, PersonStanding, ScanSearch, Shield, Workflow, Zap } from 'lucide-react';
import type { VocabularyKind } from '../api/types';
import { LISTS } from './lists';

/** Where the Configuration screens live; each area below has its own list at `/physio/configuration/<slug>` and its own form at `…/new` and `…/<id>`. */
export const CONFIG_ROOT = '/physio/configuration';
export const EXERCISES_ROOT = '/physio/exercises';
export const PATHWAY_SLUG = 'injury-pathway';
export const TEMPLATES_SLUG = 'assessment-templates';
export const RETURN_TEMPLATES_SLUG = 'return-templates';

export interface ConfigArea {
  slug: string;
  title: string;
  icon: LucideIcon;
}

const LIST_ICONS: Record<VocabularyKind, LucideIcon> = {
  mechanisms: Zap,
  'activity-contexts': Activity,
  'injury-types': Bandage,
  'body-regions': PersonStanding,
  'treatment-types': HandHeart,
  exercises: Dumbbell,
  'investigation-types': ScanSearch,
  'support-types': Shield,
  'return-criteria': ClipboardCheck,
};

/** What Physiotherapy keeps as configuration, in the order the menu shows it. A simple list's slug is its kind. */
const ALL_AREAS: ConfigArea[] = [
  { slug: PATHWAY_SLUG, title: 'Injury pathway', icon: Workflow },
  ...LISTS.map((definition) => ({ slug: definition.kind, title: definition.title, icon: LIST_ICONS[definition.kind] })),
  // Kept so the history they produced stays readable; no new injury uses them since October 2026.
  { slug: RETURN_TEMPLATES_SLUG, title: 'Return-to-sport checklists (earlier)', icon: Flag },
  { slug: TEMPLATES_SLUG, title: 'Assessment templates (earlier)', icon: ClipboardList },
];

/** Current workflow settings. Old structured investigation/checklist/template routes remain available for compatibility. */
export const AREAS = ALL_AREAS.filter((area) => !['exercises', 'investigation-types', 'return-criteria', TEMPLATES_SLUG, RETURN_TEMPLATES_SLUG].includes(area.slug));

export const areaOf = (slug: string): ConfigArea => ALL_AREAS.find((area) => area.slug === slug)!;

export const configPath = (slug: string, id?: string) => `${slug === 'exercises' ? EXERCISES_ROOT : `${CONFIG_ROOT}/${slug}`}${id ? `/${id}` : ''}`;
